function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M25.491 24.268l.7 3.733-3.325-2.216c-1.166.466-2.45.7-3.85.7-4.142 0-7.642-2.275-8.692-5.367-.175-.584-.292-1.225-.292-1.867 0-4.025 4.026-7.292 8.984-7.292 2.334 0 4.434.7 6.009 1.867C26.833 15.167 28 17.093 28 19.25c0 1.925-.933 3.675-2.509 5.017z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#CDD6E0",
  d: "M24.387 15.984H13.595v1.459h10.792v-1.459zM26.547 18.727H11.555v1.458h14.992v-1.458zM24.387 21.643H13.595V23.1h10.792v-1.458z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2F2F2",
  d: "M12.426 0C5.542 0 0 4.55 0 10.209c0 2.217.875 4.258 2.333 5.892l-1.225 5.483 4.55-2.858c1.926 1.05 4.26 1.633 6.768 1.633 6.883 0 12.425-4.55 12.425-10.209C24.91 4.55 19.31 0 12.426 0z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#84DBFF",
  d: "M5.837 12.25c1.128 0 2.042-.915 2.042-2.042 0-1.128-.914-2.042-2.042-2.042-1.127 0-2.041.914-2.041 2.042 0 1.127.914 2.041 2.041 2.041zM12.428 12.25c1.128 0 2.042-.915 2.042-2.042 0-1.128-.914-2.042-2.042-2.042-1.127 0-2.041.914-2.041 2.042 0 1.127.914 2.041 2.041 2.041zM19.08 12.25c1.128 0 2.042-.915 2.042-2.042 0-1.128-.914-2.042-2.042-2.042-1.127 0-2.042.914-2.042 2.042 0 1.127.915 2.041 2.042 2.041z"
});

function SvgComment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 29,
    fill: "none",
    viewBox: "0 0 28 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/Comment.9a67f49b.svg";
export { ForwardRef as ReactComponent };